import { render, staticRenderFns } from "./project-template-admin-quick-buttons.vue?vue&type=template&id=89d1ba34"
import script from "./project-template-admin-quick-buttons.vue?vue&type=script&lang=js"
export * from "./project-template-admin-quick-buttons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports